import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Client } from 'app/core/models/clients.model';
import { DbService } from 'app/core/services/db.service';
import { PartnersComponent } from 'app/menu/components/partners/partners.component';
import { Menu } from 'app/menu/models/menu.model';
import { Restaurant } from 'app/menu/models/restaurants.model';
import { MenuService } from 'app/menu/services/menu.service';
import { COLLECTIONS_BD } from '../../models/collections.model';
import { TYPE_MENU, TYPE_SERVICES } from '../../models/constans.model';

@Component({
    selector: 'app-sidemenu',
    templateUrl: './sidemenu.component.html',
    styleUrls: ['./sidemenu.component.scss'],
    standalone: false
})
export class SidemenuComponent implements OnInit {
  /**
   * Informacion del restaurante actual
   */
  @Input() restaurant: Restaurant = {} as Restaurant;
  /**
   * Informacion del menu seleccionado
   */
  @Input() menu: Menu = {} as Menu;
  /**
   * Indica si se debe visualizar el boton de menu
   */
  @Input() isShowButton = false;
  /**
   * Idioma seleccionado
   */
  language = 'ES';
  /**
   * Informacion del cliente al que pertenece el restaurante
   */
  client: Client = {} as Client;
  /**
   * Indica si se debe de visualizar el menu lateral
   */
  public sidebarShow = false;
  /**
   * Indica si es mobile o no
   */
  public isMobile = false;
  /**
   * Tipos de servicios del restaurante
   */
  readonly SERVICES = TYPE_SERVICES;
  /**
   * Tipos de menu del restaurante
   */
  readonly TYPES_MENU = TYPE_MENU;

  constructor(
    private router: Router,
    public menuService: MenuService,
    private activateRoute: ActivatedRoute,
    private db: DbService,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.getClient();
    }, 2000);
    this.menuService.getLang().subscribe((lan: string) => {
      this.language = lan;
    });
    this.menuService.getSideMenu().subscribe((menu: boolean) => {
      this.sidebarShow = menu;
    });
    this.menuService.getIsMobile().subscribe((value: boolean) => {
      this.isMobile = value;
      if (!value) {
        this.sidebarShow = true;
      }
    });
  }

  /**
   * Indica que se debe de ver el home
   */
  goHome(): void {
    this.dialog.closeAll();
    if (this.restaurant.home) {
      const isDetail = this.router.url.indexOf('menu-detail');
      this.menuService.setHome(true);
      this.router.navigateByUrl(`menu/${this.activateRoute.snapshot.params.id}`);
      // if (isDetail !== -1) {
      //   this.menuService.setHome(true);
      //   this.router.navigateByUrl(`menu/${this.activateRoute.snapshot.params.id}`);
      // } else {
      //   this.menuService.setHome(true);
      // }
    } else {
      this.router.navigateByUrl(`menu/${this.activateRoute.snapshot.params.id}`);
    }
  }

  /**
   * Navega a la pagina de reservas
   */
  goReserve(): void {
    this.dialog.closeAll();
    this.menuService.setHome(true);
    this.router.navigateByUrl(`reserve/${this.activateRoute.snapshot.params.id}`);
  }

  /**
   * Navega a la pagina de aliados
   */
  goPartners(): void {
    this.sidebarShow = false;
    this.dialog.open(PartnersComponent);
  }

  /**
   * Navega al menu indicado
   *
   * @param type tipo de menu
   */
  goMenu(type: string): void {
    this.router.navigateByUrl(`menu-detail/${this.activateRoute.snapshot.params.id}/${type}`);
    this.dialog.closeAll();
  }

  /**
   * Valida si tiene o no el menu indicado
   *
   * @param type tipo de menu
   * @returns boolean
   */
  hasMenu(type: string): boolean {
    switch (type) {
      case 'cocina':
      case 'bar':
        return this.restaurant.menuType === TYPE_MENU.twoMenu
          || this.restaurant.menuType === TYPE_MENU.threeMenu || this.restaurant.menuType === TYPE_MENU.fourMenu ? true : false;
      case 'brunch':
        return (this.restaurant.menuType === TYPE_MENU.threeMenu || this.restaurant.menuType === TYPE_MENU.fourMenu)
          && !this.restaurant.brunchOff ? true : false;
      case 'extra':
        return (this.restaurant.menuType === TYPE_MENU.fourMenu) ? true : false;
      default:
        return this.restaurant.menuType === (TYPE_MENU.twoMenu || TYPE_MENU.threeMenu) ? true : false;
    }
  }

  /**
   * Establece el valor de la variable que
   * indica si se visualiza o no el sidemenu
   */
  setSideMenu(): void {
    this.sidebarShow = !this.sidebarShow;
    this.menuService.setSideMenu(this.sidebarShow);
  }
  /**
   * Obtiene el color de fondo segun configuracion
   * del menu
   *
   * @returns string hex color
   */
  getMenuColor(): string {
    if (this.menu.invertColor) {
      return this.menu.colorText;
    }
    return this.menu.color;
  }

  /**
   * Obtiene el color de texto segun configuracion
   * del menu
   *
   * @returns string hex color
   */
  getMenuColorText(): string {
    if (this.menu.invertColor) {
      return this.menu.color;
    }
    return this.menu.colorText;
  }

  /**
   * Valida si se esta en la pagina de la opcion
   * seleccionada y cambia los colores para visualizar
   * que se esta en esa opcion
   *
   * @param option opcion del menu
   * @returns colores para la option del menu
   */
  getColors(option: string) {
    const withBackground = {
      background: this.menu.color,
      color: this.menu.colorText
    };
    const withoutBackground = {
      background: this.menu.invertColor ? this.menu.color : this.menu.colorText,
      color: this.menu.invertColor ? this.menu.colorText : this.menu.color,
    };
    if (this.activateRoute.snapshot.params.type === option) {
      if (this.menu.background === '' || !this.menu.background) {
        return withoutBackground;
      } else {
        return withBackground;
      }
    }
    return {
      background: (this.menu.background === '' || !this.menu.background) ?
        (this.menu.invertColor ? this.menu.colorText : this.menu.color) : '',
      color: this.menu.invertColor ? this.menu.color : this.menu.colorText,
    };

  }

  /**
   * Obtiene el label del menu de bar
   * valida si tiene uno personalizado o sino pone
   * el por defecto segun el idioma
   *
   * @returns label para el menu de bar
   */
  getLabelBarMenu(): string {
    return this.menuService.getLabelMenu(this.restaurant.labelBarMenu ? this.restaurant.labelBarMenu : '');
  }

  /**
   * Obtiene el label del menu de bar
   * valida si tiene uno personalizado o sino pone
   * el por defecto segun el idioma
   *
   * @returns label para el menu de comida
   */
  getLabelFoodMenu(): string {
    return this.menuService.getLabelMenu(this.restaurant.labelFoodMenu ? this.restaurant.labelFoodMenu : '');
  }

  getBackground(): string {
    if (this.menu.background && this.menu.background !== '' && !this.menu.imageSideMenu && this.menu.imageSideMenu === '') {
      return this.menu.background;
    } else {
      return '';
    }
  }

  /**
   * Obtiene la informacion del cliente al que
   * pertenece el restaurante
   */
  private getClient(): void {
    this.db.findOne(COLLECTIONS_BD.clients, this.restaurant.idClient).subscribe((client: any) => {
      this.client = client;
    });
  }

}
